import React from "react"

import style from "./../dialog.module.css"

const ProjectDetailsDialog = ({ onClose, project }) => {
	const wrapperRef = React.useRef()

	const clickOnWrapper = (e) => {
		if (e.target === wrapperRef.current) onClose()
	}

	const changeImage = (direction) => {
		let index = direction + selectedImage
		if (index < 0) setSelectedImage(project.images.length - 1)
		else if (index === project.images.length) setSelectedImage(0)
		else setSelectedImage(index)
	}

	const [selectedImage, setSelectedImage] = React.useState(0)

	return (
		<div className={style.dialogWrapper} ref={wrapperRef} onClick={clickOnWrapper}>
			<div className={`${style.dialogContainer} row`}>
				<div className={`${style.imagesContainer} col col-12 col-sm-12 col-md-6 col-lg-6`}>
					<img src={project.images[selectedImage]} alt={project.name} />
					{project.images.length > 1 ? (
						<>
							<i className="fas fa-chevron-right" onClick={() => changeImage(1)}></i>
							<i className="fas fa-chevron-left" onClick={() => changeImage(-1)}></i>
						</>
					) : null}
				</div>
				<div className={`${style.projectDetails} col col-12 col-sm-12 col-md-6 col-lg-6`}>
					<i className={"fas fa-times " + style.exit} onClick={onClose}></i>
					<h3>{project.name}</h3>
					<div className={style.roles}>
						{project.roles.map((role, index) => (
							<small className={style.role} key={index}>
								{role}
							</small>
						))}
					</div>

					<h4>Description</h4>
					<p className={style.description}>{project.description}</p>

					<div className={style.time}>
						<p>
							Started at: <span>{project.createdTime}</span>
						</p>
						<p>
							Duration: <span>{project.duration}</span>
						</p>
					</div>

					<h4>Technologies</h4>
					<div className={style.techs}>
						{project.technologies.map((tech, index) => (
							<div className={style.tech} key={index}>
								{tech}
							</div>
						))}
					</div>

					{project.siteUrl ? (
						<a className={style.siteUrl} href={project.siteUrl}>
							Visit Website
						</a>
					) : null}
				</div>
			</div>
		</div>
	)
}

export default ProjectDetailsDialog
